<template>
    <div class="skillInfo assessment-mb" :class="{'skillInfoPC':$store.state.innerWidth>768}">
      <div class="topic-pc">
         <div class="info-content">
             <div>
                <h2 class="Bold mainColor center">{{$t('message.Interest-Career Quiz')}}</h2>
                <p class="dscr pad-b-10">{{$t('message.interestDesc1')}}</p>
                <p class="dscr pad-b-10">
                  {{$t('message.interestDesc2')}}
                  <span class="SemiBold" v-html="$t('message.interestDesc3')"></span>
                  {{$t('message.interestDesc4')}}
                </p>
                <p class="dscr pad-b-10">{{$t('message.interestDesc5')}}</p>
                <p class="dscr pad-b-10">{{$t('message.interestDesc6')}}</p>
             </div>
             <div class="row likeGroup">
               <div class="col-xs-6 col-sm-4">
                 <div class="item-table">
                   <div class="tdcell imgwidth">
                     <img src="../images/assessment/interest-1.png" />
                   </div>
                   <div class="tdcell">
                     <p class="text">{{$t('message.Strongly Dislike')}}</p>
                   </div>
                 </div>
               </div>
               <div class="col-xs-6 col-sm-4">
                 <div class="item-table">
                   <div class="tdcell imgwidth">
                     <img src="../images/assessment/interest-2.png" />
                   </div>
                   <div class="tdcell">
                     <p class="text">{{$t('message.Dislike')}}</p>
                   </div>
                 </div>
               </div>
               <div class="col-xs-6 col-sm-4">
                 <div class="item-table">
                   <div class="tdcell imgwidth">
                     <img src="../images/assessment/interest-3.png" />
                   </div>
                   <div class="tdcell">
                     <p class="text">{{$t('message.Unsure')}}</p>
                   </div>
                 </div>
               </div>
               <div class="col-xs-6 col-sm-4">
                 <div class="item-table">
                   <div class="tdcell imgwidth">
                     <img src="../images/assessment/interest-4.png" />
                   </div>
                   <div class="tdcell">
                     <p class="text">{{$t('message.Like')}}</p>
                   </div>
                 </div>
               </div>
               <div class="col-xs-6 col-sm-4">
                 <div class="item-table">
                   <div class="tdcell imgwidth">
                     <img src="../images/assessment/interest-5.png" />
                   </div>
                   <div class="tdcell">
                     <p class="text">{{$t('message.Strongly Like')}}</p>
                   </div>
                 </div>
               </div>
             </div>
         </div>
         <div class="info-content">
            <p class="dscr pad-b-10">
              {{$t('message.interestDesc7')}}
            </p>
            <p class="">
              {{$t('message.interestDesc8')}}
            </p>
         </div>
         <div class="li-content">
             <div>
                 <div class="startBtn">
                    <div class="btn btn-primary" @click="startEvent()" role="button" :aria-label="$t('message.Start')">
                      <a href="javascript:;" style="color: inherit">{{$t('message.Start')}}</a>
                    </div>
                 </div>
             </div>
         </div>
                 <a class="displayA" v-bind:href="'./InterestAssessmentTopic?lang='+$store.state.language"></a>
       </div>
    </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
export default {
    components: {
       Breadcrumbs
    },
    data() {
        return {
            
        }
    },   
    props: ["logGaEvent"],
    created(){
    },
    methods: {
      startEvent:function(){
          this.logGaEvent('userClick','InterestAssessment',"InterestAssessmentTopic")
        this.$router.push({ path: '/InterestAssessmentTopic' , query:{lang:this.$store.state.language}});
         window.scrollTo(0, 0);
      }
    },
    mounted() {
        this.$store.state.selectMenu =5;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
    }


   
}
</script>